import React from "react";
import {
  Box,
  Stack,
  ExternalLink,
  InternalLink,
  ExternalLinkIcon,
  util
} from "@thecb/components";
import { fallbackValues } from "./LinkCard.theme";
import * as Styled from "./LinkCard.styled";

const { themeComponent } = util.theme;

const LinkCard = ({
  title = "Test Workflow",
  subtitle = "Link your benefit plan",
  subtitlePadding = "0 0 40px",
  showLeft,
  leftContent,
  showRight,
  rightContent,
  href,
  extraStyles = "",
  extraHoverStyles = "",
  extraActiveStyles = "",
  themeValues,
  titleVariant = "h3",
  disabled = false,
  isExternalLink = false
}) => {
  const regex = /\W/g;
  const locatorSlug = title?.toLowerCase?.()?.replaceAll?.(regex, "-");

  const baseStyles = Styled.getCardBaseStyles(
    themeValues,
    disabled,
    extraStyles
  );
  const hoverActiveStyles = Styled.getCardHoverActiveStyles(
    themeValues,
    disabled,
    extraHoverStyles,
    extraActiveStyles
  );

  const cardContent = (
    <Stack
      childGap={0}
      bottomItem={3}
      justify="space-between"
      style={{ width: "100%" }}
      fullHeight
    >
      <Stack
        direction="row"
        childGap="0.5rem"
        extraStyles={`align-items: center;`}
      >
        <Styled.Title
          variant={titleVariant}
          $theme={themeValues}
          margin={0}
          $disabled={disabled}
        >
          {title}
        </Styled.Title>
        {isExternalLink && (
          <ExternalLinkIcon
            linkColor={themeValues.color}
            text={locatorSlug}
            style={{ height: "1.125rem", width: "1.125rem" }}
          />
        )}
      </Stack>
      <Box padding={subtitlePadding} width="100%">
        <Styled.Subtitle variant="pS" $theme={themeValues} $disabled={disabled}>
          {subtitle}
        </Styled.Subtitle>
      </Box>
      <Box
        background="transparent"
        borderWidthOverride="0 0 0 0"
        padding="0"
        width="100%"
      >
        <Styled.Footer direction="row" childGap="6px" justify="space-between">
          {/* To keep rightContent aligned right, use an empty Box as leftContent if none is provided */}
          {showLeft && !!leftContent ? (
            leftContent
          ) : (
            <Box extraStyles="margin-right: auto;" />
          )}
          {showRight && !!rightContent && rightContent}
        </Styled.Footer>
      </Box>
    </Stack>
  );

  if (isExternalLink) {
    return (
      <ExternalLink
        key={`link-card-${locatorSlug}`}
        href={disabled ? undefined : href}
        newTab={true}
        isUnderlined={false}
        tabIndex={disabled ? "-1" : "0"}
        ariaLabel={`${title}, ${subtitle}`}
        dataQa={`link-card-${locatorSlug}`}
        extraStyles={`${baseStyles} ${hoverActiveStyles}`}
      >
        {cardContent}
      </ExternalLink>
    );
  }

  return (
    <InternalLink
      key={`link-card-${locatorSlug}`}
      to={disabled ? undefined : href}
      isUnderlined={false}
      hoverUnderline={false}
      tabIndex={disabled ? "-1" : "0"}
      aria-label={`${title}, ${subtitle}`}
      aria-disabled={disabled}
      data-qa={`link-card-${locatorSlug}`}
      extraStyles={`${baseStyles} ${hoverActiveStyles}`}
    >
      {cardContent}
    </InternalLink>
  );
};

export default themeComponent(LinkCard, "LinkCard", fallbackValues, "primary");
